import { render } from "./LbrxDisplaySingleBlocTheme.vue?vue&type=template&id=7dbf66e6&scoped=true"
import script from "./LbrxDisplaySingleBlocTheme.vue?vue&type=script&lang=js"
export * from "./LbrxDisplaySingleBlocTheme.vue?vue&type=script&lang=js"

import "./LbrxDisplaySingleBlocTheme.vue?vue&type=style&index=0&id=7dbf66e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbf66e6"]])

export default __exports__